import React from 'react';
import PropTypes from 'prop-types';
import plusIcon from '@common/images/plus.svg';
import minusIcon from '@common/images/minus.svg';
import plusDisabled from '@common/images/plus-disabled.svg';
import minusDisabled from '@common/images/minus-disabled.svg';
import {Image} from '@learningblocks/shared-components';
import {Button} from '../Button';

import { useTranslation } from "react-i18next";

import style from './style.module.scss';

export function PreciseStepper(props) {

  const {
    t,
    // i18n
  } = useTranslation("translation");

  const underflow = () => props.currentValue === props.min;
  const overflow = () => props.currentValue === props.max;

  const timerRight = React.useRef(null);
  const timerLeft = React.useRef(null);
  const [currentVal, setCurrentVal] = React.useState(props.currentValue);
  let counter = 0;
  let currVal = props.currentValue;

  React.useEffect(()=>{
    setCurrentVal(props.currentValue);
  }, [props.currentValue]);

  const holdingRight = () => {
    if(currVal === props.max){clearTimeout(timerRight.current);}
    else{
      if(props.keyboardStep !== "auto"){
        props.onChange(Number((currentVal + props.step + (counter*props.step)).toFixed(6)));
        currVal = Number((currentVal + props.step + (counter*props.step)).toFixed(6));
      }
      else if(props.ariaInterval + counter < props.altTextData.length - 1 && props.altTextData[props.ariaInterval + 1 + counter].keyboardStep !== ""){
        props.onChange(Number((parseFloat(props.altTextData[props.ariaInterval + 1 + counter].keyboardStep)).toFixed(6)));
        currVal = Number((parseFloat(props.altTextData[props.ariaInterval + 1 + counter].keyboardStep)).toFixed(6))
      }
      else {clearTimeout(timerRight.current);}
      counter++;
      if(counter > 25){timerRight.current = setTimeout(holdingRight, 25);}
      else if(counter > 7){timerRight.current = setTimeout(holdingRight, 100);}
      else{timerRight.current = setTimeout(holdingRight, 250);}
    }
  };

  const releaseRight = () => {
    counter = 0;
    clearTimeout(timerRight.current);
  };

  const holdingLeft = () => {
    if(currVal === props.min){clearTimeout(timerLeft.current);}
    else{
      if(props.keyboardStep !== "auto"){
        props.onChange(Number((currentVal - props.step - (counter*props.step)).toFixed(6)));
        currVal = Number((currentVal - props.step - (counter*props.step)).toFixed(6));
      }
      else if(props.keyboardStep === "auto" && props.ariaInterval - counter !== 0 && props.altTextData[props.ariaInterval - 1 - counter].keyboardStep !== ""){
        props.onChange(Number((parseFloat(props.altTextData[props.ariaInterval - 1 - counter].keyboardStep)).toFixed(6)));
        currVal = Number((parseFloat(props.altTextData[props.ariaInterval - 1 - counter].keyboardStep)).toFixed(6));
      }
      else {clearTimeout(timerLeft.current);}
      counter++;
      if(counter > 25){timerLeft.current = setTimeout(holdingLeft, 25);}
      else if(counter > 7){timerLeft.current = setTimeout(holdingLeft, 100);}
      else{timerLeft.current = setTimeout(holdingLeft, 250);}
    }
  };

  const releaseLeft = () => {
    counter = 0;
    clearTimeout(timerLeft.current);
  };

  return (
    <>
      <Button
        className={style.stepperPrecise}
        disabled={underflow()}
        normalicon={<Image role="presentation" src={minusIcon} onContextMenu={(e)=>{e.preventDefault()}}/>}
        disabledicon={<Image role="presentation" src={minusDisabled} />}
        // onTouchStart={holdingLeft} onTouchEnd={releaseLeft}
        onMouseDown={holdingLeft} onMouseUp={releaseLeft}
        onKeyDown={(e)=>{
          if (e.repeat) { return }
          let keycode = (e.keyCode ? e.keyCode : e.which)
          if(keycode === 13){holdingLeft()}
        }}
        onKeyUp={(e)=>{
          let keycode = (e.keyCode ? e.keyCode : e.which)
          if(keycode === 13){releaseLeft()}
        }}
        ariaLabel={t("sliderLeft.string")}
      ></Button>
      <div className={style.stepperPrecise_currentValue}>
        {props.currentValue}{props.unit}
      </div>
      <Button
        className={style.stepperPrecise}
        disabled={overflow()}
        normalicon={<Image role="presentation" src={plusIcon} onContextMenu={(e)=>{e.preventDefault()}}/>}
        disabledicon={<Image role="presentation" src={plusDisabled} />}
        // onTouchStart={holdingRight} onTouchEnd={releaseRight}
        onMouseDown={holdingRight} onMouseUp={releaseRight}
        onKeyDown={(e)=>{
          if (e.repeat) { return }
          let keycode = (e.keyCode ? e.keyCode : e.which)
          if(keycode === 13){holdingRight()}
        }}
        onKeyUp={(e)=>{
          let keycode = (e.keyCode ? e.keyCode : e.which)
          if(keycode === 13){releaseRight()}
        }}
        ariaLabel={t("sliderRight.string")}
      ></Button>
    </>
  );
}

PreciseStepper.propTypes = {
  /**
   * lowest value possible
   */
  min: PropTypes.number,
  /**
   * highest value possible
   */
  max: PropTypes.number,
  /**
   * current value
   */
  currentValue: PropTypes.number,
  /**
   * increment/decremnet step
   */
  step: PropTypes.number,
};
